// extracted by mini-css-extract-plugin
export default {"container":"index_container_ik4c7","containerLogo":"index_containerLogo_jb7OD"};